export namespace SettingsCompany {
    
  export enum Settings {
    IdDossierPrinting="IdDossierPrinting",
    IdGoodsMovementPrinting="IdGoodsMovementPrinting",
    IdInboundDeliveryNotePrinting="IdInboundDeliveryNotePrinting",
    IdInboundPending="IdInboundPending",
    IdInboundPrinting="IdInboundPrinting",
    IdOutboundDeliveryNotePrinting="IdOutboundDeliveryNotePrinting",
    IdOutboundPrinting="IdOutboundPrinting",
    IdStockLabelPrinting="IdStockLabelPrinting",
    IdStockListCustomerPrinting="IdStockListCustomerPrinting",
    IdStockListPrinting="IdStockListPrinting",
    IdStockMovementPrinting="IdStockMovementPrinting",
    IdStockListGroupPrinting="IdStockListGroupPrinting",
    IdStockListCustomerAvailable="IdStockListCustomerAvailable",
    IdStockMovementsDatesPrinting="IdStockMovementsDatesPrinting",
    IdStockMovements28="IdStockMovements28",
    IdStockMovements29="IdStockMovements29",
    IdStockMovements30="IdStockMovements30",
    IdStockMovements31="IdStockMovements31",
    IdStockReport="IdStockReport",
    IdUserCanModifyInOutbounds="IdUserCanModifyInOutbounds",
    IdInboundOutboundSellPrinting="IdInboundOutboundSellPrinting",
    ValidationT1="ValidationT1",
    GenerateCode="GenerateCode",
    StockRepportWarehousesCompanies="StockRepportWarehousesCompanies",
    ShowCustomer="ShowCustomer",
    ShowEntrepotRequiredFields="ShowEntrepotRequiredFields",
    IdReportBilling28="IdReportBilling28",
    IdReportBilling29="IdReportBilling29",
    IdReportBilling30="IdReportBilling30",
    IdReportBilling31="IdReportBilling31",
    IdReportStockByCompanyDestination28="IdReportStockByCompanyDestination28",
    IdReportStockByCompanyDestination29="IdReportStockByCompanyDestination29",
    IdReportStockByCompanyDestination30="IdReportStockByCompanyDestination30",
    IdReportStockByCompanyDestination31="IdReportStockByCompanyDestination31",
    CanDuplicateOutboundsCode="CanDuplicateOutboundsCode",
    InboundDetailLanguageText="InboundDetailLanguageText",
    BORInboundDetailParse="BORInboundDetailParse",
    BOLDRApiKey="BOLDRApiKey",
    StandAlone="StandAlone",
    Scanner="Scanner",
    ShowStockCustom="ShowStockCustom",
    ValidationAGP="ValidationAGP",
    Licence="Licence",
    CustomerStockCustomFields="CustomerStockCustomFields",
    ShowSku="ShowSku",
    InboundImportExcel="InboundImportExcel",
    OutboundImportXml="OutboundImportXml",
    CustomerStockOrderFields="CustomerStock-",
    CustomerStockGroupByOrderFields="CustomerStockGroupBy-",
    EnableAGPExciseModule="EnableAGPExciseModule",
    Maandaangifte="Maandaangifte",
    ShowCustomerInLabel="ShowCustomerInLabel",
    IdMaandaangifte="IdMaandaangifte",
  }
}
